// 获取 logo 和 bg
import request from "./request";
import Vue from "vue";

const emptyUser = {userId: 0, userName: '', email: '', phoneNumber: '(+1)0'}

const meta = {
  logo: '',
  bg: '',
  banner: [{},{},{},{}],
  link: '',
  user: {},
  emailValidation: false,
  async fetchLoginUserData() {
    Vue.set(meta, 'banner', (await request('/businese/banner')).data)
    Vue.set(meta, 'link', (await request('/businese/link')).data)
    Vue.set(meta, 'user', (await request('/businese/user_info/loginUserInfo')).data || emptyUser)
    localStorage.setItem('link', this.link)
    localStorage.setItem('banner', JSON.stringify(this.banner))
    localStorage.setItem('user', JSON.stringify(this.user))
  }
}

// 远程获取基础数据
request({
  url: '/businese/display'
}).then(({data}) => {
  Vue.set(meta, 'logo', data.logo)
  Vue.set(meta, 'bg', data.background)
  Vue.set(meta, 'emailValidation', data.emailValidation === 'true')

  localStorage.setItem('logo', data.logo)
  localStorage.setItem('bg', data.background)
  localStorage.setItem('emailValidation', data.emailValidation)
})

// 已登录却未获取数据时获取数据
if (localStorage.getItem('Authorization') && !meta.link) {
  if (localStorage.getItem('user')) {
    // 直接获取本地存储的数据
    Vue.set(meta, 'link', localStorage.getItem('link'))
    Vue.set(meta, 'banner', JSON.parse(localStorage.getItem('banner')))
    Vue.set(meta, 'user', JSON.parse(localStorage.getItem('user')))
  } else {
    meta.fetchLoginUserData().then().catch()
  }
}

window.meta = meta
export default meta



// WEBPACK FOOTER //
// ./src/utils/meta.js